import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const alarmParametersService = {
    list: async (payload) => axios.get(API_URL + "/alarmParameters/list", payload).then(({ data }) => data).catch((err) => { throw err }),
    
    update: async (payload) => axios.put(API_URL + "/alarmParameters/update", payload).then(({ data }) => data).catch((err) => { throw err }),
};

export default alarmParametersService;